import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const RegistriesPageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
